import{useEffect,useRef}from"react";export const usePrevious=value=>{const ref=useRef();return useEffect((()=>{ref.current=value}),[value]),ref.current};